import React from 'react';
import { useNavigate } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import { motion } from 'framer-motion';

export default function Home() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-slate-50 flex flex-col">
      {/* Header */}
      <header className="bg-white border-b border-slate-200 py-4 px-6 md:px-12 flex items-center justify-between">
        <div className="flex items-center">
          <img 
            src="https://media-manager-c.questera.ai/greta-media/525d05658fdf988acaa34e738d3f286826191483600217441074af5254e1324b9947d16ec384fcc03e2360d22f6a7d9b/images/aW1hZ2UvcG5n/312034cd79c028aad1e85c1e994b94aa.png" 
            alt="Pinoy General Insurance Logo" 
            className="h-24 md:h-32 object-contain"
          />
        </div>
        <div className="hidden md:flex items-center gap-4 text-sm font-bold text-[#1E40AF]">
          <span className="flex items-center gap-1 bg-blue-50 px-4 py-2 rounded-full border border-blue-100">
            <SafeIcon icon="FiPhone" /> (562) 402-1737
          </span>
        </div>
      </header>

      {/* Main Content */}
      <main className="flex-1 flex items-center justify-center p-6 bg-gradient-to-b from-white to-slate-50">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          className="max-w-2xl w-full bg-white rounded-2xl shadow-2xl overflow-hidden border border-slate-100"
        >
          <div className="bg-[#1E40AF] p-8 md:p-12 text-center text-white relative overflow-hidden">
            <div className="absolute top-0 right-0 opacity-10 transform translate-x-1/4 -translate-y-1/4">
              <SafeIcon icon="FiHome" className="text-9xl" />
            </div>
            <h1 className="text-3xl md:text-5xl font-bold mb-4 relative z-10 leading-tight">
              Is Your Home Fully Protected?
            </h1>
            <p className="text-blue-100 text-lg md:text-xl max-w-lg mx-auto relative z-10 font-medium">
              Take our 2-minute quiz to find out if you're underinsured, overpaying, or have hidden coverage gaps.
            </p>
          </div>
          
          <div className="p-8 md:p-12 bg-white flex flex-col items-center">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-10 w-full">
              <div className="flex flex-col items-center text-center gap-2">
                <div className="w-14 h-14 rounded-full bg-green-100 flex items-center justify-center text-[#10B981] shadow-sm">
                  <SafeIcon icon="FiClock" className="text-2xl" />
                </div>
                <h3 className="font-bold text-slate-800">Takes 2 mins</h3>
                <p className="text-sm text-slate-500">6 simple questions</p>
              </div>
              <div className="flex flex-col items-center text-center gap-2">
                <div className="w-14 h-14 rounded-full bg-blue-100 flex items-center justify-center text-[#1E40AF] shadow-sm">
                  <SafeIcon icon="FiTrendingUp" className="text-2xl" />
                </div>
                <h3 className="font-bold text-slate-800">Identify Gaps</h3>
                <p className="text-sm text-slate-500">Find missing coverage</p>
              </div>
              <div className="flex flex-col items-center text-center gap-2">
                <div className="w-14 h-14 rounded-full bg-orange-100 flex items-center justify-center text-[#F97316] shadow-sm">
                  <SafeIcon icon="FiDollarSign" className="text-2xl" />
                </div>
                <h3 className="font-bold text-slate-800">Save Money</h3>
                <p className="text-sm text-slate-500">Stop overpaying</p>
              </div>
            </div>

            <button 
              onClick={() => navigate('/quiz')}
              className="bg-[#10B981] hover:bg-emerald-600 text-white text-xl font-bold py-5 px-12 rounded-2xl shadow-xl hover:shadow-2xl transition-all transform hover:-translate-y-1 w-full md:w-auto flex items-center justify-center gap-3"
            >
              Start Free Coverage Review
              <SafeIcon icon="FiArrowRight" />
            </button>
            <p className="mt-6 text-xs text-slate-400 text-center font-medium">
              100% FREE • SECURE & CONFIDENTIAL • NO COMMITMENT
            </p>
          </div>
        </motion.div>
      </main>
    </div>
  );
}